import { staticText, Translated } from '../../utils/translations/staticText';

// Copy from BRD-01 (CMS-2000) where it gives one.
export const TRANSLATIONS = staticText({
  cc_card_trending_rank: { _: 'Trending #:rank', zh: '熱門第 :rank 位' },
  cc_card_earn_rate: { _: 'Earn rate', zh: '賺取比率' },
  cc_card_up_to: { _: 'Up to :rate', zh: '高達 :rate' },
  cc_card_as_low_as: { _: 'As low as :rate', zh: '低至 :rate' },
  // A dollars-per-mile rate.
  cc_card_per_mile: { _: ':amount/mile', zh: ':amount/里' },
  cc_card_currency_cashback: { _: 'Cashback', zh: '現金回贈' },
  cc_card_currency_miles: { _: 'Miles', zh: '飛行里數' },
  cc_card_currency_explainer: {
    _: 'Miles are the issuer’s reward currency. The issuer sets how many miles each dollar earns and the redemption rate.',
    zh: '飛行里數為發卡機構的獎賞貨幣，每元可賺取的里數及兌換比率由發卡機構決定。',
  },
  cc_card_currency_explainer_label: {
    _: 'About this reward currency',
    zh: '關於此獎賞貨幣',
  },
  cc_card_registration_required: {
    _: 'Registration req.',
    zh: '需登記',
  },
  cc_card_registration_note: {
    _: 'Register with the issuer to earn this rate.',
    zh: '須向發卡機構登記方可享此回贈率。',
  },
  cc_card_min_monthly_spend: {
    _: 'Min. monthly spend :amount',
    zh: '每月最低消費 :amount',
  },
  cc_card_annual_fee: { _: 'Annual fee', zh: '年費' },
  cc_card_annual_fee_free: { _: 'Free', zh: '免年費' },
  cc_card_first_year_waived: { _: '1st yr waived', zh: '首年豁免' },
  // A waiver over another period, as authored ("First 5 years", "首2年").
  cc_card_fee_waived: { _: ':period waived', zh: ':period豁免' },
  cc_card_min_income: { _: 'Min. annual income', zh: '最低年薪' },
  cc_card_min_income_none: { _: 'None', zh: '免入息' },
  cc_card_per_year: { _: 'per year', zh: '每年' },
  cc_card_moneyhero_exclusive: {
    _: 'MoneyHero Exclusive',
    zh: 'MoneyHero 獨家',
  },
  cc_card_more_rewards: {
    _: '+:count more reward option|+:count more reward options',
    zh: '另有 :count 個獎賞選擇|另有 :count 個獎賞選擇',
  },
  cc_card_fewer_rewards: { _: 'Show fewer options', zh: '收起獎賞選擇' },
  cc_card_highest_value: { _: 'Highest value', zh: '最高價值' },
  cc_card_top_up: { _: 'Top-up', zh: '換購' },
  cc_card_bank_offer: { _: 'Bank welcome offer', zh: '銀行迎新獎賞' },
  cc_card_promo_ends: { _: 'Promo ends :date', zh: '推廣期至 :date' },
  cc_card_days_left: {
    _: ':days day left|:days days left',
    zh: '僅餘 :days 天|僅餘 :days 天',
  },
  cc_card_last_day: { _: 'Last day', zh: '最後一天' },
  cc_card_estimate_title: { _: 'Estimated benefits', zh: '預計回贈' },
  // 回贈 is a rebate; a miles card earns miles.
  cc_card_estimate_title_miles: { _: 'Estimated benefits', zh: '預計里數' },
  // The figure is labelled as an estimate wherever it shows (FR-1.6.7).
  cc_card_estimate_prompt: {
    _: 'Estimated: what :spend/month gets you',
    zh: '預計：每月消費 :spend 可賺取',
  },
  cc_card_estimate_cashback_line: {
    _: '~:yearly cashback a year',
    zh: '全年約 :yearly 現金回贈',
  },
  cc_card_estimate_miles_line: {
    _: ':destination economy in ~:months month|:destination economy in ~:months months',
    zh: ':destination經濟艙約 :months 個月|:destination經濟艙約 :months 個月',
  },
  cc_card_estimate_miles_yearly_line: {
    _: '~:miles miles a year',
    zh: '全年約 :miles 里',
  },
  cc_card_estimate_assumption: {
    _: 'Estimate based on spending :spend a month',
    zh: '以每月消費 :spend 估算',
  },
  cc_card_estimate_monthly_cashback: { _: 'Monthly cashback', zh: '每月回贈' },
  cc_card_estimate_yearly_cashback: { _: 'Yearly cashback', zh: '全年回贈' },
  cc_card_estimate_monthly_miles: { _: 'Monthly miles', zh: '每月里數' },
  cc_card_estimate_yearly_miles: { _: 'Yearly miles', zh: '全年里數' },
  cc_card_estimate_miles_amount: { _: ':miles miles', zh: ':miles 里' },
  cc_card_estimate_economy_months: {
    _: 'Economy ~:months month|Economy ~:months months',
    zh: '經濟艙 ~:months 個月|經濟艙 ~:months 個月',
  },
  cc_card_estimate_business_months: {
    _: 'Business ~:months month|Business ~:months months',
    zh: '商務艙 ~:months 個月|商務艙 ~:months 個月',
  },
  cc_card_details: { _: 'Details', zh: '詳情' },
  cc_card_apply_now: { _: 'Apply Now', zh: '立即申請' },
  cc_card_not_available: { _: 'Not Available', zh: '暫不開放' },
});

export type CcProductCardTranslations = Translated<typeof TRANSLATIONS>;
